import React from "react";
import { Breadcrumbs, Link } from "@mui/material";
const BreadcrumbsSubheader = ({
  links
}) => {

  const renderLinks = () => {
    return (links||[]).map((link, i) => (
      <Link
        key={`breadcrumb-link-${i}`}
        href={link.url}
        underline="hover"
        color="inherit"
      >
        {link.name}
      </Link>
    ))
  }

  return (
    <div className="container my-4">
      <Breadcrumbs
        separator="›"
      >
        {renderLinks()}
      </Breadcrumbs>
    </div>
  )
};

export default BreadcrumbsSubheader